// React
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
// Material UI
import { Button, Typography, useTheme } from "@mui/material";
// Custom UI
import CustomTable from "../../../ui/CustomTable";
import TabsList from "../../../ui/TabsList";
// Third Party Components
import FilterForm from "./FilterForm";
// Providers
import { useVendor } from "./Provider";
// Services
import { useAuth } from "../../../services/auth";
// Custom Render
import WebLinkCell from "./Table/WebLinkCell";
import DescriptionCell from "./Table/DescriptionCell";
import CompanyCell from "./Table/CompanyCell";

function List() {
  let navigate = useNavigate();
  let theme = useTheme();

  const {
    state: { list: listVendors, FilterData, totalSize },
    remove: removeVendor,
    fetchList: fetchVendors,
    dispatch,
  } = useVendor();
  const [selectedCols, setSelectedCols] = useState("Vendors");
  const [filterClick, setFilterClick] = useState(false);
  const [vState, setVState] = useState(false);
  const { role, adminOn } = useAuth();
  const tabs = [{ title: "Vendors", num: totalSize }];

  const handleDelete = async (ID) => {
    try {
      await removeVendor(ID);
      fetchVendors(FilterData);
    } catch (error) {
      console.log(error);
    }
  };

  const getCols = () => {
    return [
      { label: "Vendor Name", name: "name" },
      { label: "Vendor Company", name: "company", customRender: CompanyCell },
      { label: "Vendor Weblink", name: "weblink", customRender: WebLinkCell },
      {
        label: "Description",
        name: "description",
        customRender: DescriptionCell,
      },
    ];
  };

  const getData = () => listVendors;

  const getActions = () => {
    return {
      selectedCols: true,
      edit: (id) => {
        navigate("/store/vendors/edit/" + id);
      },
      delete: (e) => handleDelete(e),
      check: (v) => v.length > 0,
      vState: vState,
      setVState: setVState,
    };
  };

  const handleClick = () => {
    // return handleExportExcel();
  };
  return (
    <>
      <Typography variant="Poster" component="h4">
        Select Company
      </Typography>

      <FilterForm
        setFilterClick={setFilterClick}
        role={role}
        adminOn={adminOn}
      ></FilterForm>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "80%",
        }}
      >
        <TabsList
          tabs={tabs}
          setSelectedCols={setSelectedCols}
          selectedCols={selectedCols}
        ></TabsList>
        {/* {filterClick && (
          <Button
            sx={{
              border: `1px solid ${theme.color.Screamingreen}`,
              color: theme.color.Screamingreen,
              mt: "5px",
              textTransform: "capitalize",
              "&:hover": { background: `${theme.color.gray50}` },
            }}
            onClick={handleClick}
          >
            Export to Excel
          </Button>
        )} */}
      </div>

      <CustomTable
        empty={getData(selectedCols)?.length === 0 ? true : false}
        cols={getCols()}
        data={getData()}
        actions={getActions()}
        filters={{
          add: () => navigate("add"),
        }}
        dispatch={dispatch}
        isPagination={false}
      ></CustomTable>
    </>
  );
}

export default List;
